const newNonce = () => {
  return (Math.random() * Number.MAX_SAFE_INTEGER).toString(16).substring(0, 8);
};

export default newNonce;
